<template>
	<el-aside class="leftbox">
		<h2>{{ group }}</h2>
		<div class="menubox">
			<ul>
				<li v-for="(item, index) in menus" :key="item.id" :class="item.class">
					<dl>
						<dt @click="setSelect(item.id)">
							<span>{{ item.title }}</span>
						</dt>
					</dl>
				</li>
			</ul>
			<div class="menu-foot"></div>
		</div>
	</el-aside>
</template>

<script>
	export default {
		name: 'InfoLeftSide',
		props: {
			group: {
				type: String,
				default: '系统相关'
			},
			menus: {
				type: Array,
				default: function () {
					return [];
				}
			}
		},

		methods: {
			setSelect(id) {
				let curIndex = this.menus.findIndex(x => x.id == id);
				let curInfo = this.menus[curIndex];
				this.menus.forEach((x, i) => {
					this.menus[i]['class'] = '';
					if (curIndex == i) {
						this.menus[i]['class'] = 'is-open';
					}
				});
				this.$emit('setSelectInfo', curInfo);
				this.goto(curInfo.goto);
			}
		}
	};
</script>

<style lang="less" scoped>
	.leftbox {
		position: relative;
		width: 280px !important;
		background: #fff;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
		border-radius: 12px;
		.arrow {
			position: relative;
			display: inline-block;
			left: auto;
			top: auto;
		}
		.arrow:after {
			position: absolute;
			right: 0;
			top: -3px;
			display: block;
			content: '';
			width: 7px;
			height: 7px;
			border-top: 1px solid #334155;
			border-right: 1px solid #334155;
			transition: 0.3s;
			transform: rotate(45deg);
		}
		.arrow-down:after {
			transform: rotate(135deg);
		}
		h2 {
			height: 64px;
			margin: 0;
			padding-left: 24px;
			line-height: 64px;
			font-size: 18px;
			font-weight: 700;
			color: #fff;
			background: linear-gradient(135deg, #155dfc, #4f39f6);
			border-radius: 12px 12px 0 0;
		}
		.menubox {
			padding-bottom: 30px;
			background-color: #fff;
			position: relative;
			height: calc(100% - 110px);

			ul {
				position: relative;
				z-index: 10;
				margin: 0;
				padding: 0;
			}
			li {
				line-height: 46px;
				color: #334155;
				list-style-type: none;
				font-size: 14px;
			}
			dl {
				margin: 0;
			}
			dt {
				cursor: pointer;
				height: 44px;
				padding: 0 16px;
				font-size: 15px;
				font-weight: 500;
				color: #334155;
				span {
					position: relative;
					padding-left: 20px;
					height: 100%;
					display: block;
					line-height: 44px;
				}
				span:before {
					position: absolute;
					top: 50%;
					left: 0px;
					transform: translate(0, -50%);
					content: '';
					width: 9px;
					height: 15px;
					background: url(@/assets/images/leftside/title-ico.png) no-repeat center center;
					background-size: cover;
				}
				a {
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding-left: 0;
				}
			}
			dd {
				height: 46px;
				margin: 5px 0;
				padding: 0 20px;
				display: none;
				a {
					display: block;
				}
			}
			dt:hover {
				background-color: #f8fafc;
			}
			.is-open {
				dt {
					color: #155dfc;
					background: #f1f5f9;
				}
				dd {
					display: block;
				}
				dd:hover {
					background: #fff;
				}
				.arrow:after {
					border-top: 1px solid #155dfc;
					border-right: 1px solid #155dfc;
					transform: rotate(135deg);
				}
			}
			a {
				padding-left: 20px;
				color: #334155;
				text-decoration: none;
			}
			a:hover {
				color: #155dfc;
			}
			a.is-sel {
				background-color: #eff6ff;
				border-radius: 12px;
				color: #155dfc;
			}
		}
	}

	.menu-foot {
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 1;
		width: 228px;
		height: 144px;
		background: url(@/assets/images/leftside/menu-footimg.png) no-repeat center center;
		background-size: cover;
	}

	//媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.leftbox {
			width: 26% !important;
		}
	}
</style>
